import { render, staticRenderFns } from "./SuggestionActions.vue?vue&type=template&id=805bda16"
import script from "./SuggestionActions.vue?vue&type=script&lang=js"
export * from "./SuggestionActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports